import { render, staticRenderFns } from "./textStyle.vue?vue&type=template&id=4345e57e&scoped=true&"
import script from "./textStyle.vue?vue&type=script&lang=js&"
export * from "./textStyle.vue?vue&type=script&lang=js&"
import style0 from "./textStyle.vue?vue&type=style&index=0&id=4345e57e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4345e57e",
  null
  
)

export default component.exports